// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeLayout_container__2NI54"};